









































































import { BookComponents } from '../../components'
import { bookGoodsModelProvider } from '../model'
import { computed, ref } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'
import { ImagePreview } from 'vant'
import { navigateTo } from '@/router'

export default defineClassComponent(
  {
    components: BookComponents,
  },
  () =>
    class {
      bookGoodsModel = bookGoodsModelProvider.inject()

      // 是否代金券
      isCoupon = computed(() => this.bookGoodsModel.value.isCoupon)

      // 是否兑换商品
      isExchange = computed(() => this.bookGoodsModel.value.isExchange)

      // 当前轮播项索引
      currentBannerIndex = ref(0)

      // 轮播项改变时触发
      handleBannerChange = (index: number) => {
        this.currentBannerIndex.value = index
      }

      // 点击轮播项
      handleBannerClick = (index: number) => {
        ImagePreview({
          images: this.bookGoodsModel.value.carousePic,
          startPosition: index,
        })
      }

      // 点击评价栏
      handleCommentClick = () => {
        navigateTo('BookCommentIndex', {
          goodsId: this.bookGoodsModel.value.goodsId,
        })
      }
    },
)
